import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.scss";
import { createBrowserHistory } from "history";
import { AuthContexProvider } from "./contexts/Auth/AuthContext";
import { MessageContexProvider } from "./contexts/Message/MessageContext";
import { ReactKeycloakProvider } from "@react-keycloak/web";

import keycloak from "./services/Keycloak/Keycloak";

export const history = createBrowserHistory();
ReactDOM.render(
    <React.Fragment>
        <Router>
            <ReactKeycloakProvider authClient={keycloak}>
                <MessageContexProvider>
                    <AuthContexProvider>
                        <App />
                    </AuthContexProvider>
                </MessageContexProvider>
            </ReactKeycloakProvider>
        </Router>
    </React.Fragment>,
    document.getElementById("root")
);
